import React from 'react'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'

import {
  is_logged_on,
  setFormControlClass
 } from "../helpers"

import {
  Form,
  Control,
  // Errors
} from 'react-redux-form'

import Errors from './Errors'

import {
  // validateEmailType,
  // validatePasswordLength,
  isRequired
} from "../validations"

import { loginUser } from '../actions'

const mapDispatchToProps = dispatch => {
  return {
    loginUser: values => dispatch(loginUser(values)),
    // changeField: (field, e) => dispatch(actions.change(field, e)),
    // validateField: (field, validation) => dispatch(actions.validate(field, validation))
  };
};

const mapStateToProps = (state) => {
  return {
    login: state.login,
    // fields: state.loginForm,
    form: state.forms.login,
    auth: state.auth,
    errors: state.auth.current_user.errors
  };
}
class ConnectedLogin extends React.Component {
  handleSubmit(values) {
    this.props.loginUser(values)
  }

  render() {
    const {email, password, $form} = this.props.form
    if ( is_logged_on() ) {
      return <Redirect to="/" />
    }

    let errorString = ''
    if (this.props.auth.failedLogin === true && this.props.errors !== undefined && this.props.errors.length > 0) {
      errorString = <Errors errors={this.props.errors}/>
    }

    return (
      <div className="collection with-header">

        <div className="collection-header red darken-1 white-text">
          <span className="flow-text">Login</span>
          <i className="material-icons right">account_circle</i>
        </div>

        <Form
          model="login"
          className="collection-item"
          onSubmit = {(values) => this.handleSubmit(values)}
        >

          <div className="section form-group">
            <label htmlFor="email">Email Address</label>
            <div className={ setFormControlClass(email) }>
              <Control.text id="email"
                model= "login.email" type = "email" className="form-control"
                validators={{
                  required: (val) => email.pristine || isRequired(val),
                  // validateEmailType: (val) => email.pristine || validateEmailType(val)
                }}
                />
              </div>
              {
                //   <Errors
                //   model="login.email" className="formErrors" wrapper="ul"
                //   component={ (props) => {
                //     return (
                //       <li>
                //       {props.children}
                //       </li>
                //     )
                //   }
                // }
                // messages={{
                //   required: 'Please provide an email address.',
                //   validateEmailType: (val) => `Not an email.`
                // }} />
              }
          </div>

          <div className="section form-group">
            <label htmlFor="password">Password</label>
            <div className={ setFormControlClass(password) }>
              <Control.text id="password"
                model = "login.password"
                type  = "password"
                className="form-control"
                validators={{
                  required: (val) => {
                    return password.pristine || isRequired(val)
                  },
                  // validatePasswordLength: (val) => password.pristine || validatePasswordLength(val)
                }}
                />
            </div>
            {
              //   <Errors
              //   model="login.password"
              //   wrapper="ul"
              //   component={ (props) => {
              //     return (
              //       <li>
              //       {props.children}
              //       </li>
              //     )
              //   }
              // }
              // className="formErrors"
              // messages={{
              //   required: 'Please type in your password',
              //   validatePasswordLength: 'Password is too short'
              // }} />
            }
          </div>

          { errorString }

          <div className="section form-group">
            <button className="btn red darken-1 waves-effect waves-light" type="submit" disabled={$form.pristine || !$form.valid}>
              Login
            </button>
          </div>
        </Form>
      </div>
    )
  }
}

const Login = connect(mapStateToProps, mapDispatchToProps)(ConnectedLogin);

export default Login



// WEBPACK FOOTER //
// ./src/js/components/Login.js